import axios from "../../utils/axiosConfig";
import { AddSupplierDTO } from "../../dtos/supplier";
import { PaginationDTO } from "../../dtos/manufacturer";

axios.defaults.withCredentials = true;

const getSupplier = async (pharmacy_id: any, dto?: PaginationDTO) => {
  let url = `/api/pharmacy/supplier/get?pharmacy_id=${pharmacy_id}`;

  // If dto exists, add pagination and search parameters
  if (dto) {
    url += `&page=${encodeURIComponent(dto.page)}&limit=${encodeURIComponent(
      dto.limit
    )}&search=${encodeURIComponent(dto.search)}`;
  }

  const { data } = await axios.get(url);
  return data;
};
const getSupplierBatches = async (pharmacy_id: any, supplier_id?: any) => {
  let url = `/api/pharmacy/supplier/get_supplier_batch?pharmacy_id=${pharmacy_id}&supplier_id=${supplier_id}`;

  const { data } = await axios.get(url);
  return data;
};

const AddSupplier = async (supplier: AddSupplierDTO) => {
  const { data } = await axios.post(`/api/pharmacy/supplier/add`, supplier);

  return data;
};
const editSupplier = async (supplier: AddSupplierDTO) => {
  const { data } = await axios.post("/api/pharmacy/supplier/update", supplier);
  return data;
};
const SupplierService = {
  getSupplier,
  getSupplierBatches,
  AddSupplier,
  editSupplier,
};

export default SupplierService;
